import React from 'react';
import { formatINR } from '../billingUtils';
import './InvoiceTotalsPanel.css';

const trimRate = (rate) => String(rate ?? '').replace(/\.0+$|(\.\d*?)0+$/, '$1');

/**
 * Invoice totals exactly as the server computed them (from `calculate` or a
 * saved invoice). Nothing is added up here.
 */
const InvoiceTotalsPanel = ({ totals, loading = false, error = '', placeholder = 'Select a client to see the totals.' }) => {
  if (!totals) {
    return (
      <div className="itp">
        <div className="itp-placeholder">{error || placeholder}</div>
      </div>
    );
  }

  const rate = trimRate(totals.gstRate);
  const half = trimRate(totals.halfRate) || (rate ? String(Number(rate) / 2) : '');

  return (
    <div className={`itp ${loading ? 'is-loading' : ''}`} aria-busy={loading}>
      <dl className="itp-rows">
        <div className="itp-row">
          <dt>Taxable amount</dt>
          <dd>{formatINR(totals.taxableAmount)}</dd>
        </div>

        {totals.taxType === 'IGST' && (
          <div className="itp-row">
            <dt>IGST @ {rate}%</dt>
            <dd>{formatINR(totals.igstAmount)}</dd>
          </div>
        )}

        {totals.taxType === 'CGST_SGST' && (
          <>
            <div className="itp-row">
              <dt>CGST @ {half}%</dt>
              <dd>{formatINR(totals.cgstAmount)}</dd>
            </div>
            <div className="itp-row">
              <dt>SGST @ {half}%</dt>
              <dd>{formatINR(totals.sgstAmount)}</dd>
            </div>
          </>
        )}

        {!totals.taxType && (
          <div className="itp-row itp-warn">
            <dt>Tax</dt>
            <dd>Not applied — client state unknown</dd>
          </div>
        )}

        <div className="itp-row itp-total">
          <dt>Total</dt>
          <dd>{formatINR(totals.totalAmount)}</dd>
        </div>
        <div className="itp-row">
          <dt>Received</dt>
          <dd>{formatINR(totals.receivedAmount)}</dd>
        </div>
        <div className="itp-row itp-balance">
          <dt>Current balance</dt>
          <dd>{formatINR(totals.balanceAmount)}</dd>
        </div>
      </dl>

      {totals.amountInWords && <p className="itp-words">{totals.amountInWords}</p>}
      {error && <p className="itp-error">{error}</p>}
    </div>
  );
};

export default InvoiceTotalsPanel;
